<!--打包视频教程-->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.add" @click="add(1)">{{ permission.add }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">打包规范</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Key" clearable placeholder="请输入标题"></el-input>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
            </div>
        </div>
        <template>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @cell-dblclick="handleDBClick">
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column prop="Titile" label="商品打包规范" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="Creator" label="创建人" show-overflow-tooltip></el-table-column>
                    <el-table-column width="180px" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="Updator" label="更新人" show-overflow-tooltip></el-table-column>
                    <el-table-column width="180px" prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="编辑" size="mini" type="text" v-if="permission.edit" @click="add(2, scope.row)">编辑</el-button>
                                <el-button size="mini" style="color: red" @click="del(scope.row)" v-if="permission.del" type="text">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: { elTableColumn, breadcrumb },
    data() {
        return {
            noData: false,
            Id: '',
            searchData: {
                Key: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getPermission('packVideo');
    },
    methods: {
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetEntpGoodsPackVideoList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该数据吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpCustomers/DelEntpGoodsPackVideo?id=' + row.Id
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        add(type,data) {
            if(type == 1){
                this.$router.push(`/logistics/packVideo/addPackVideo`);
            }else{
                this.$router.push(`/logistics/packVideo/addPackVideo?Id=`+data.Id+`&Type=`+type);
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.add(3, event);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.qp-msg {
    padding-bottom: 10px;
    p {
        padding-top: 10px;
    }
}
.qp-ctn {
    display: flex;
    flex-wrap: wrap;
}
.qp-item {
    width: 250px;
    margin-right: 20px;
    margin-bottom: 20px;
}
.qp-cover {
    text-align: center;
    overflow: hidden;
    img {
        max-height: 218px;
        max-width: 218px;
    }
}
.search-item{
    margin-right: 20px;
}
.ops-ctn {
    display: flex;
}
@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}
@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
.my-select {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .phone {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .phone {
            color: #ddd;
        }
    }
}
</style>
<style lang="less">
.el-table .warning-row {
    background: oldlace;
}
.el-table .success-row {
    background: #f0f9eb;
}
.el-table .error-row {
    background: rgb(255, 176, 176);
}
</style>
